export function paginationGoToFirstPage(grid) {
    if (grid.OnPaginationFirst) {
        grid.OnPaginationFirst();
    }
    else if (grid.usePaging) {
        grid.changeGridPage("FIRST");
    }
}
export function paginationGoToPreviousPage(grid) {
    if (grid.OnPaginationPrevious) {
        grid.OnPaginationPrevious();
    }
    else if (grid.usePaging) {
        grid.changeGridPage("PREV");
    }
}
export function paginationGoToNextPage(grid) {
    if (grid.OnPaginationNext) {
        grid.OnPaginationNext();
    }
    else if (grid.usePaging) {
        grid.changeGridPage("NEXT");
    }
}
export function paginationGoToLastPage(grid) {
    if (grid.OnPaginationLast) {
        grid.OnPaginationLast();
    }
    else if (grid.usePaging) {
        grid.changeGridPage("LAST");
    }
}
export function paginationGoToPage(grid, page) {
    if (page === 1) {
        grid.changeGridPage("FIRST");
    }
    else {
        grid.eof = 0;
        grid.firstRecordOnPage = (grid.pageSize * (page - 1) -
            grid.pageSize).toString();
        grid.changeGridPage("NEXT");
    }
}
